import { Box, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface BenefitsLandingHeaderProps {
  content: {
    hero: {
      title: string
      subtitle: string
      cta: string
      media: {
        src: string
      }
    }
  }
}

const BenefitsLandingHeader = ({ content }: BenefitsLandingHeaderProps) => {
  return (
    <Box className="mx-auto" alignItems="center" textAlign="center" gap="s12">
      <Text size="700" color="black" weight="bold">
        {content.hero.title}
      </Text>
      <Text size="400" className="mb-4">
        {content.hero.subtitle}
      </Text>
      <UpsellingKit.UpsellButton
        label={content.hero.cta}
        requestSource="benefits-landing"
        pageSource="benefits-landing"
        requestReason={ValidReasons.MissingAddon}
        moduleRequested={AvailableModules.benefits}
        featureRequested={Features.benefits_core}
      />
      <Box
        paddingTop="s24"
        borderRadius={{ all: 'abs016' }}
        overflowX="hidden"
        className="max-h-[450px] w-[800px]"
      >
        <video
          src={content.hero.media.src}
          className="rounded-lg max-h-[450px]"
          style={{ display: 'block', width: '100%', maxWidth: '800px' }}
          autoPlay
          muted
          loop
        />
      </Box>
    </Box>
  )
}

export default BenefitsLandingHeader
